// extracted by mini-css-extract-plugin
export default {"fieldList":"Dashboard_tsx_fieldList__G9xCu"};